import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
/* Fuente Raleway local - Sin dependencia de Google Fonts */
@import url('/assets/fonts/raleway/raleway.css');

* {
  margin: 0;
  padding: 0;
  outline: none;
  font-family: "Rubik", sans-serif;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

input, textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

${({ $isTerminal }) =>
  $isTerminal
    ? `
  *::-webkit-scrollbar {
    display: none;
  }
  * {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`
    : ""}

/* Fuentes Rubik */
.rb70b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 70px;
}
.rb52b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 52px;
}
.rb48b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
}
.rb48m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
}
.rb40b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
}
.rb40m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 40px;
}
.rb36b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
}
.rb36m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
}
.rb32b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
}
.rb32m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
}
.rb24b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
}
.rb24m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
}
.rb24t {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
}
.rb22b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
}
.rb22t {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
}
.rb18b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
}
.rb18mh {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
}
.rb18m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
}
.rb18l {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

/* Rubik 100%/16 Rubik 100% (Bold) */
.rb16xl {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
}

.rb16b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
}
.rb16mh {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
}
.rb16m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}
.rb16l {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}
.rb16t {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}
.rb14b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
}
.rb14m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
.rb14l {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.rb14t {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}
.rb12b {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
}
.rb12m {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
}
.rb12l {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}
.rb12t {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
}
.rb12tl {
  line-height: 150%;
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
}

.c-primary {
  color: hsla(24, 100%, 50%, 1);
}
.c-secondary {
  color: hsla(11, 100%, 70%, 1);
}
.c-disabled {
  color: hsla(11, 100%, 80%, 1);
}
.c-danger {
  color: hsla(4, 100%, 40%, 1);
}
.c-latex30 {
  color: hsla(202, 100%, 30%, 1);
}
.c-latex10 {
  color: hsla(202, 100%, 10%, 1);
}
.c-white {
  color: hsla(0, 0%, 100%, 1);
}
.c-grey97 {
  color: hsla(0, 0%, 97%, 1);
}
.c-grey95 {
  color: hsla(0, 0%, 95%, 1);
}
.c-grey90 {
  color: hsla(0, 0%, 90%, 1);
}
.c-grey85 {
  color: hsla(0, 0%, 85%, 1);
}
.c-grey65 {
  color: hsla(0, 0%, 65%, 1);
}
.c-grey55 {
  color: hsla(0, 0%, 55%, 1);
}
.c-grey45 {
  color: hsla(0, 0%, 45%, 1);
}
.c-grey25 {
  color: hsla(0, 0%, 25%, 1);
}
.c-black35 {
  color: hsla(0, 0%, 35%, 1);
}
.c-black20 {
  color: hsla(0, 0%, 20%, 1);
}
.c-black10 {
  color: hsla(0, 0%, 10%, 1);
}
.c-black5 {
  color: hsla(0, 0%, 5%, 1);
}
.c-black {
  color: hsla(0, 0%, 0%, 1);
}

.c-broccoli {
  color: hsla(128, 43%, 42%, 1);
}

.bgc-primary {
  background-color: hsla(24, 100%, 50%, 1);
}
.bgc-secondary {
  background-color: hsla(11, 100%, 70%, 1);
}
.bgc-disabled {
  background-color: hsla(11, 100%, 80%, 1);
}
.bgc-danger {
  background-color: hsla(4, 100%, 40%, 1);
}
.bgc-latex95 {
  background-color: hsla(202, 100%, 95%, 1);
}
.bgc-latex30 {
  background-color: hsla(202, 100%, 30%, 1);
}
.bgc-latex10 {
  background-color: var(--color-latex10);
}
.bgc-white {
  background-color: hsla(0, 0%, 100%, 1);
}
.bgc-grey97 {
  background-color: hsla(0, 0%, 97%, 1);
}
.bgc-grey95 {
  background-color: hsla(0, 0%, 95%, 1);
}
.bgc-grey90 {
  background-color: hsla(0, 0%, 90%, 1);
}
.bgc-grey85 {
  background-color: hsla(0, 0%, 85%, 1);
}
.bgc-grey65 {
  background-color: hsla(0, 0%, 65%, 1);
}
.bgc-grey45 {
  background-color: hsla(0, 0%, 45%, 1);
}
.bgc-black35 {
  background-color: hsla(0, 0%, 35%, 1);
}
.bgc-black20 {
  background-color: hsla(0, 0%, 20%, 1);
}
.bgc-black10 {
  background-color: hsla(0, 0%, 10%, 1);
}
.bgc-black5 {
  background-color: hsla(0, 0%, 5%, 1);
}
.bgc-black {
  background-color: hsla(0, 0%, 0%, 1);
}

.bgc-green28 {
  background-color: hsla(173, 100%, 28%, 1);
}

.bgc-Facebook {
  background-color: #4c69ba;
}

.bgc-broccoli {
  background-color: hsla(128, 43%, 42%, 1);
}

.bgc-transparent {
  background-color: transparent;
}

/* Gradiente Headers */
.bgcG-latex30 {
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
}

.bgcG-danger {
  background: linear-gradient(95.53deg, #730700 1.56%, #c10c00 65.41%);
}

.b-latex30 {
  border: 1px #006299 solid;
}
/* Hover */
.hoverLatex95:hover {
  background: var(--color-latex95);
}
.hoverSecondary:hover {
  background: var(--color-secondary);
}
/* Colores */
:root {
  --color-primary: hsla(24, 100%, 50%, 1);
  --color-secondary: hsla(11, 100%, 70%, 1);
  --color-disabled: hsla(11, 100%, 80%, 1);
  --color-danger: hsla(4, 100%, 40%, 1);
  --color-latex95: hsla(202, 100%, 95%, 1);
  --color-latex30: hsla(202, 100%, 30%, 1);
  --color-scrollbar: hsla(202, 100%, 30%, 1);
  --color-latexPcr: #02507c;
  --color-white: hsla(0, 0%, 100%, 1);
  --color-grey97: hsla(0, 0%, 97%, 1);
  --color-grey95: hsla(0, 0%, 95%, 1);
  --color-grey90: hsla(0, 0%, 90%, 1);
  --color-grey85: hsla(0, 0%, 85%, 1);
  --color-grey77: hsla(0, 0%, 77%, 1);
  --color-grey65: hsla(0, 0%, 65%, 1);
  --color-grey45: hsla(0, 0%, 45%, 1);
  --color-black35: hsla(0, 0%, 35%, 1);
  --color-black20: hsla(0, 0%, 20%, 1);
  --color-black10: hsla(0, 0%, 10%, 1);
  --color-black5: hsla(0, 0%, 5%, 1);
  --color-black: hsla(0, 0%, 0%, 1);
  --color-green28: hsla(173, 100%, 28%, 1);
  --color-broccoli: hsla(128, 43%, 42%, 1);
  --color-latex10: #002133;
  ${({ mode }) => {
    if (mode === "blue") {
      return `
            --color-primary-gradient: linear-gradient(90deg, #001019 18.65%, #014e7a 86.55%);
            --color-primary-gradient-y: linear-gradient(180deg, #001019 18.65%, #014e7a 86.55%);
            --color-primary-footer: #002133 ;
            --color-latex10: #002133;
            --color-resaltado: #002133;
            --color-secondary-gradient: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
            --color-green-gradient: linear-gradient(87.1deg, #006F12 17.72%, #00C21F 85.58%);
            --color-grey-greadient:  linear-gradient(90deg, #717171 1.76%, #333333 100%);
            `;
    } else if (mode === "silver")
      return `
          --color-green-gradient: linear-gradient(87.1deg, #006F12 17.72%, #00C21F 85.58%);
          --color-primary-gradient: linear-gradient(90deg, #717171 1.76%, #333333 100%);
          --color-primary-footer: #333333;
          --color-latex10: #333333; 
          --color-scrollbar: #ff6600; 
          --color-resaltado: #333333;
          --color-secondary-gradient: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
        `;
  }}
}

/* Image rotates */

.img-rotated-90 {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
  transition: 0.3s all;
}

.img-rotated180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  transition: 0.3s all;
}
.img-rotatedX180 {
  transform: rotateX(-0.5turn);
  transition: 0.3s all;
}

.m-0 {
  margin: 0px;
}
.pointer {
  cursor: pointer;
}

.btn {
  padding: 12px 56px;
}

.btnAdjust {
  padding: 12px 40px;
  min-width: 100px;
  border-radius: 8px;
  margin: 8px;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
}

.f-left {
  float: left;
}
.f-right {
  float: right;
}

/* comentamos la siguiente clase utilizada para bloquear la seleccion */
/* .noSeleccionable {
  -webkit-touch-callout: none; 
  -webkit-user-select: none; 
  -khtml-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none; 
} */

.textCenter {
  text-align: center;
}
.clear {
  clear: both;
}

.underline {
  text-decoration: underline;
}

/* .iosMobileStatusBarFix{
  padding-top: 40px;
  height: 85px;
  @media (max-width: 1365px) {
    height: 85px;
  };
}; */

/* Effecto Opaccity */

.OpacityEffect {
  animation-name: OpacityEffect;
}

@keyframes OpacityEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}


.ptur-modal-mantenimiento{
  width:800px;
  z-index:10;
  height:100vh;
  height:100dvh;
  width:100vw;
  display:flex;
  justify-content:center;
  align-items:center;
}

`;
